import { applyMiddleware, compose, createStore } from 'redux';
import { createMigrate, persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import createSagaMiddleware from 'redux-saga';
import rootReducer from './reducer';
import rootSaga from './saga';
import { setPersistor } from './persistor';
import { PERSIST_VERSION, persistMigrations } from './persistMigrations';

export default (initialState = {}) => {
  // ==========================================================================
  // Persist Configuration
  // ==========================================================================
  const persistConfig = {
    key: 'root',
    storage,
    version: PERSIST_VERSION,
    migrate: createMigrate(persistMigrations),
    whitelist: ['user','chat','family','externalCalendar','article','notes','event','subscriptions','ui']
  };
  const persistedReducer = persistReducer(persistConfig, rootReducer);
  // ==========================================================================
  // Middleware Configuration
  // ==========================================================================
  const sagaMiddleware = createSagaMiddleware();

  // ==========================================================================
  // Store Enhancers
  // ==========================================================================
  const composeWithDevTools = process.env.NODE_ENV === 'development' &&
    (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
  const composeEnhancers = composeWithDevTools || compose;
  // ==========================================================================
  // Store Insantiation and HMR Setup
  // ==========================================================================
  const store = createStore(
    persistedReducer,
    initialState,
    composeEnhancers(
      applyMiddleware(sagaMiddleware),
    )
  );

  sagaMiddleware.run(rootSaga);

  const persistor = persistStore(store);
  setPersistor(persistor); // make persistor accessible to sagas

  return {
    store,
    persistor
  };
};



// WEBPACK FOOTER //
// ./src/createStore.ts